<p-toast></p-toast>
<p-confirmDialog header="Confirmation" icon="pi pi-exclamation-triangle"></p-confirmDialog>

<p-card *ngIf="!EstCharge()">
	<div class="fluid formgrid grid">
		<div class="flex flex-column gap-2 col-12 text-center">
			<p-progressSpinner></p-progressSpinner>
		</div>
	</div>
</p-card>



<div *ngIf="EstCharge()" class="grid">
	<div class="col-12">
		<p-card>
				<div class="fluid formgrid grid">
					
					<div class="flex flex-column gap-2 col-12 lg:col-6">
						<label for="lastname">Fournisseur</label>
								<p-dropdown [options]="fournisseurs" [(ngModel)]="selectionFournisseur" optionLabel="nom" [showClear]="true" 
									filter="true" filterBy="numero,nom"
									placeholder="Sélectionner un fournisseur...">
									<ng-template pTemplate="selectedItem">
										<div *ngIf="selectionFournisseur">
											<div>{{selectionFournisseur.nom}} ({{selectionFournisseur.numero}})</div>
										</div>
									</ng-template>
									<ng-template let-fournisseur pTemplate="item">
										<div>
											<div>{{fournisseur.nom}} ({{fournisseur.numero}})</div>
										</div>
									</ng-template>
								</p-dropdown>
								<small class="p-error" *ngIf="submitted && !selectionFournisseur">Le fournisseur est obligatoire.</small>
					</div>
				</div>
				<div class="fluid formgrid grid">
					<div class="flex flex-column gap-2 col-12 md:col-6 lg:col-3">
						<label for="lastname">Date de début d'effectivité</label>
						<p-calendar appendTo="body" showIcon=true [(ngModel)]="dateDebut" dateFormat="yy-mm-dd" [yearNavigator]="true" [monthNavigator]="true" yearRange="2000:2040" ></p-calendar>
						<small class="p-error" *ngIf="submitted && !dateDebut">La date de début d'effectivité est obligatoire.</small>
					</div>
					<div class="flex flex-column gap-2 col-12 md:col-6 lg:col-3">
						<label for="lastname">Date de fin d'effectivité</label>
						<p-calendar appendTo="body" showIcon=true [(ngModel)]="dateFin" dateFormat="yy-mm-dd" [yearNavigator]="true" [monthNavigator]="true" yearRange="2000:2040" ></p-calendar>
						<small class="p-error" *ngIf="submitted && !datefin">La date de fin d'effectivité est obligatoire.</small>
					</div>
					<div class="flex flex-column gap-2 col-12 md:col-6 lg:col-3">
						<label for="lastname">Date de début de disponibilité</label>
						<p-calendar appendTo="body" showIcon=true [(ngModel)]="dateDebutSaisie" dateFormat="yy-mm-dd" [yearNavigator]="true" [monthNavigator]="true" yearRange="2000:2040" ></p-calendar>
						<small class="p-error" *ngIf="submitted && !dateDebutSaisie">La date de début de disponibilité est obligatoire.</small>
					</div>
					<div class="flex flex-column gap-2 col-12 md:col-6 lg:col-3">
						<label for="lastname">Date de fin de disponibilité</label>
						<p-calendar appendTo="body" showIcon=true [(ngModel)]="dateFinSaisie" dateFormat="yy-mm-dd" [yearNavigator]="true" [monthNavigator]="true" yearRange="2000:2040" ></p-calendar>
						<small class="p-error" *ngIf="submitted && !dateFinSaisie">La date de fin de disponibilité est obligatoire.</small>
					</div>
				</div>
				
			<div class="col-12 text-right">
				<p-button label="Dupliquer" (click)="dupliquer()" icon="pi pi-save"
					iconPos="left"></p-button>
					<button pButton pRipple label="Annuler" icon="pi pi-ban" class="p-button-text" (click)="annuler()"></button>
			</div>
		</p-card>
	</div>


</div>